var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: false,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.supplier"),
                          prop: "supplierCode",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t("QuotationCenter.supplier"),
                            "option-list": _vm.supplierAllList,
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.supplierCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "supplierCode", $$v)
                            },
                            expression: "queryParams.supplierCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.logisticsChannel"),
                          prop: "logisticsChannelCode",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "QuotationCenter.logisticsChannel"
                            ),
                            "option-list": _vm.logisticsChannelAllList,
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.logisticsChannelCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "logisticsChannelCode",
                                $$v
                              )
                            },
                            expression: "queryParams.logisticsChannelCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.status"),
                          prop: "status",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t("QuotationCenter.status"),
                            "option-list": _vm.statusList,
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.effectiveStatus"),
                          prop: "effective",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "QuotationCenter.effectiveStatus"
                            ),
                            "option-list": _vm.effectiveStatusList,
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.effective,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "effective", $$v)
                            },
                            expression: "queryParams.effective",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.currency"),
                          prop: "currency",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t("QuotationCenter.currency"),
                            "option-list": _vm.currencyList,
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.currency,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "currency", $$v)
                            },
                            expression: "queryParams.currency",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.effectiveTime"),
                          prop: "effectiveTime",
                        },
                      },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            "tip-show": true,
                            placeholder: _vm.$t(
                              "QuotationCenter.effectiveTime"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParamsTime_effectiveTime,
                            callback: function ($$v) {
                              _vm.queryParamsTime_effectiveTime = $$v
                            },
                            expression: "queryParamsTime_effectiveTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("table.remarkText"),
                          prop: "remark",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: { placeholder: _vm.$t("table.remarkText") },
                          model: {
                            value: _vm.queryParams.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "remark", $$v)
                            },
                            expression: "queryParams.remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.onAdd()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("addText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled:
                            tableOperationProp.notSelected ||
                            _vm.hasSelectedStatus(1),
                          type: "primary",
                          plain: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onEnable()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("enableText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled:
                            tableOperationProp.notSelected ||
                            _vm.hasSelectedStatus(0),
                          type: "primary",
                          plain: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onDisable()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("QuotationCenter.status3")))]
                    ),
                    _c("BjFrontendExport", {
                      attrs: {
                        disabled: tableOperationProp.notSelected,
                        "label-list": _vm.labelList,
                        rows: _vm.selectedRows,
                        "file-name": "Supplier Quotation.csv",
                        type: "primary",
                        plain: "",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:BusinessDeleteQuotationButton",
                            arg: "BusinessDeleteQuotationButton",
                          },
                        ],
                        attrs: {
                          disabled: tableOperationProp.notSelected,
                          type: "primary",
                          plain: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.batchDelete()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("bulkDelText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    col.prop == "status"
                                      ? [
                                          [0, 1, 2].includes(
                                            scope.row[col.prop]
                                          )
                                            ? _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    type:
                                                      scope.row[col.prop] == 1
                                                        ? "success"
                                                        : scope.row[col.prop] ==
                                                          2
                                                        ? "warning"
                                                        : "info",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          _vm.statusList.bjGet(
                                                            scope.row[col.prop]
                                                          )
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : col.prop == "effective"
                                      ? [
                                          [0, 1].includes(scope.row[col.prop])
                                            ? _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    type:
                                                      scope.row[col.prop] == 1
                                                        ? "success"
                                                        : "info",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row[col.prop] == 1
                                                          ? _vm.$t(
                                                              "QuotationCenter.Active"
                                                            )
                                                          : _vm.$t(
                                                              "QuotationCenter.Expired"
                                                            )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("quotationTimeFilter")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onEdit(props.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("editText")))]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onCopy(props.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("copyText")))]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "delete-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onView(props.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("detailsText")))]
                                      ),
                                    ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogFormVisible,
            width: "550px",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCenter.supplier"),
                            prop: "supplierCode",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t("QuotationCenter.supplier"),
                              disabled: "",
                            },
                            model: {
                              value: _vm.form.supplierName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "supplierName", $$v)
                              },
                              expression: "form.supplierName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCenter.logisticsChannel"),
                            prop: "logisticsChannelCode",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCenter.logisticsChannel"
                              ),
                              "option-list": _vm.logisticsChannelList,
                            },
                            on: { change: _vm.handleLogisticsChannelChange },
                            model: {
                              value: _vm.form.logisticsChannelCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "logisticsChannelCode", $$v)
                              },
                              expression: "form.logisticsChannelCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("QuotationCenter.currency"),
                    prop: "currency",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      placeholder: _vm.$t("QuotationCenter.currency"),
                      "option-list": _vm.currencyList,
                    },
                    model: {
                      value: _vm.form.currency,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "currency", $$v)
                      },
                      expression: "form.currency",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("QuotationCenter.effectiveTime"),
                    prop: "effectiveTime",
                  },
                },
                [
                  _c("el-date-picker", {
                    staticClass: "full-width",
                    attrs: {
                      prop: "effectiveTime",
                      format: "dd/MM/yyyy HH:mm:ss",
                      type: "datetimerange",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "start-placeholder": _vm.$t("form.startDateText"),
                      "end-placeholder": _vm.$t("form.endDateText"),
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    model: {
                      value: _vm.queryParamsTime_form_effectiveTime,
                      callback: function ($$v) {
                        _vm.queryParamsTime_form_effectiveTime = $$v
                      },
                      expression: "queryParamsTime_form_effectiveTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("table.remarkText"), prop: "remark" },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      placeholder: _vm.$t("inputText"),
                      type: "textarea",
                      rows: 5,
                      "show-word-limit": "",
                      autosize: "",
                      maxlength: "500",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveAmount()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }